import {CHeliCarnelianPositionChannelProvider} from './CHeliCarnelianPositionChannelProvider';

import type {CRPConnectionType} from '../../../../CRPClient/dist/scripts/types/misc';

export class CHeliCarnelianPrismPositionChannelProvider extends CHeliCarnelianPositionChannelProvider {
  protected readonly connectionType: CRPConnectionType = 'prism';
}
